"use strict";
/* -force_new_hash- */
Object.defineProperty(exports, "__esModule", { value: true });
const webjs_sdk_1 = require("@aria/webjs-sdk");
const react_dom_1 = require("react-dom");
require("./app.scss");
const AppBootstrapper_1 = require("./AppBootstrapper");
const Utils_1 = require("./helpers/Utils");
const TelemetryEvents_1 = require("./models/telemetry/TelemetryEvents");
const FeaturesService_1 = require("./services/FeaturesService");
const Logger_1 = require("./services/Logger");
const TelemetryScenarioTracker_1 = require("./services/TelemetryScenarioTracker");
const OneDsSerivce_1 = require("./services/OneDsSerivce");
const ServerParamsService_1 = require("./services/ServerParamsService");
const ConfigurationService_1 = require("./services/ConfigurationService");
const LogsCollectorService_1 = require("./services/LogsCollectorService");
const ServiceWorkerController_1 = require("./services/ServiceWorkerController");
const ServiceWorkerHealthCheck_1 = require("./helpers/ServiceWorkerHealthCheck");
// ServerParamsService must always initialize before ConfigurationService to pick the environment from PDS
ServerParamsService_1.default.init();
ConfigurationService_1.configurationService.init(ServerParamsService_1.default.getServerParams().environment);
const appBootstrapper = new AppBootstrapper_1.default();
if (FeaturesService_1.default.getFeatureFlags().enableAria) {
    Logger_1.default.init();
}
OneDsSerivce_1.OneDS.init();
TelemetryScenarioTracker_1.TelemetryScenarioTracker.init();
const startScenario = TelemetryScenarioTracker_1.TelemetryScenarioTracker.getOrCreateScenario(TelemetryScenarioTracker_1.ScenarioNames.JoinLauncherStart);
startScenario.start();
window.onerror = (message, source, line, col, error) => {
    const errorEvent = new TelemetryEvents_1.GenericErrorEvent({
        message: Utils_1.Utils.scrubEuii(message.toString()),
        error: JSON.stringify({
            source: Utils_1.Utils.stripQSPFromUrl(source),
            line,
            col,
            error: Utils_1.Utils.scrubEuii((error === null || error === void 0 ? void 0 : error.stack) || ""),
        }),
    });
    Logger_1.default.log(errorEvent, webjs_sdk_1.AWTEventPriority.Immediate_sync);
};
window.addEventListener("beforeunload", () => {
    // in case the start scenario did not complete before app is unloaded, cancel it
    startScenario.cancel("Unloaded");
    Logger_1.default.log(new TelemetryEvents_1.UnloadLauncherEvent());
    Logger_1.default.flushAndTeardown();
    appBootstrapper.cleanup();
});
document.addEventListener("keydown", event => {
    if (Utils_1.Utils.logsCollectorKeyCombination(event)) {
        LogsCollectorService_1.default.download();
    }
});
function initServiceWorker() {
    try {
        const swMode = FeaturesService_1.default.getFeatureFlags().serviceWorkerRegistration;
        if (swMode) {
            ServiceWorkerController_1.default.run();
        }
    }
    catch (error) {
        const errorEvent = new TelemetryEvents_1.GenericErrorEvent({
            message: "ServiceWorkerController initialization failed",
            error: JSON.stringify(error),
        });
        Logger_1.default.log(errorEvent, webjs_sdk_1.AWTEventPriority.Immediate_sync);
    }
}
const container = document.getElementById("launcherApp");
if (container) {
    appBootstrapper.bootstrap().then(element => {
        (0, react_dom_1.render)(element, container);
        startScenario.stop();
        (0, ServiceWorkerHealthCheck_1.completeServiceWorkerHealthCheck)();
        if ((0, ServiceWorkerHealthCheck_1.isServiceWorkerRecoverySession)()) {
            Logger_1.default.log(new TelemetryEvents_1.ServiceWorkerHealthCheckRecoveryEvent(), webjs_sdk_1.AWTEventPriority.Immediate_sync);
        }
        else {
            initServiceWorker();
        }
    }, error => startScenario.fail(JSON.stringify(error)));
}
